import { BASE_URL, FAQS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { ApiResponse } from "./auth";
import { IFaqs, IFaqsInput } from "models/faqs";
import { HeadCell } from "models/app";


export async function getFaqs(params: string = "") : Promise<ApiResponse<IFaqs[]>> {
  const response = await axios.get(BASE_URL + FAQS + params);
  return response.data;
}


export async function addFaq(data: IFaqsInput) {
  const response = await axios.post(BASE_URL + FAQS, data);
  return response.data;
}
export async function editFaq(data: IFaqsInput, id: string) {
  const response = await axios.patch(BASE_URL + FAQS + `/${id}` , data);
  return response.data;
}

export async function deleteFaq(id: string) {
  const response = await axios.delete(BASE_URL + FAQS + `/${id}`);
  return response.data;
}


export const FaqsCells: HeadCell[] = [
  {
    id: "question",
    numeric: false,
    disablePadding: false,
    label: "Question",
    
  },
  {
    id: "answer",
    numeric: false,
    disablePadding: false,
    label: "Answer",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "Actions",
  },
];